import apiInstance from "../axiosConfig";
import { DB_ENDPOINTS } from "../endpoints";
export const logUiLogs = (networkBrand, logs) => apiInstance.post(DB_ENDPOINTS.LOGS(networkBrand), logs);
